import { __assign, __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import MobileCollectionPopup from '../MobileCollectionPopup';
import DesktopCollectionPanel from '../DesktopCollectionPanel';
import DeviationDumbView from '../../DeviationViews/Dumbo';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import Modal from '../../Popup/Modal';
import s from './CollectionModal.scss';
var CollectionModal = /** @class */ (function (_super) {
    __extends(CollectionModal, _super);
    function CollectionModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            var _a = _this.props, undoChanges = _a.undoChanges, requestClose = _a.requestClose, deviationId = _a.collectibleDeviation.deviationId;
            undoChanges(deviationId);
            requestClose();
        };
        return _this;
    }
    CollectionModal.prototype.render = function () {
        var isMobile = this.props.isMobile;
        return (React.createElement(Modal, { onRequestClose: this.onClose, withCloseButton: true, isOpen: true, width: "auto", height: "auto" },
            !isMobile && this.renderPopup(),
            isMobile && React.createElement(MobileCollectionPopup, __assign({}, this.props))));
    };
    CollectionModal.prototype.renderPopup = function () {
        var collectibleDeviation = this.props.collectibleDeviation;
        return (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement("div", { className: s['container'] },
                React.createElement("div", { className: s['left'] },
                    React.createElement(DeviationDumbView, { width: 196, deviation: collectibleDeviation })),
                React.createElement(DesktopCollectionPanel, __assign({}, this.props)))));
    };
    return CollectionModal;
}(React.Component));
export { CollectionModal };
export default withMobileContext(withTranslation()(CollectionModal));
//# sourceMappingURL=CollectionModal.js.map